import { render, staticRenderFns } from "./channelCrmDetailReport.vue?vue&type=template&id=fcea452a"
import script from "./channelCrmDetailReport.vue?vue&type=script&lang=js"
export * from "./channelCrmDetailReport.vue?vue&type=script&lang=js"
import style0 from "./channelCrmDetailReport.vue?vue&type=style&index=0&id=fcea452a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports